export enum UsersFilterStorageKey {
  Filter = 'users_filter_model_filter',
  SelectedUserId = 'users_filter_model_selected_user',
}
